// Whether lower is better on a gauge: it's reversed, or its metric is one
// where a fall is good. The peer comparison ranks its percentile this way
// (100 the best), and its ends are labelled to match.
const isGaugeLowerBetter = ({
  gauge,
  metric,
}: {
  gauge: Pick<VisualisationDefinitions.Gauge, 'isReversed'>;
  metric: { formatting: MetricFormatting } | undefined;
}): boolean =>
  !!gauge.isReversed ||
  (!!metric && metric.formatting.positiveDeltaIsGood === false);

export default isGaugeLowerBetter;
